module.exports = __webpack_public_path__ + "static/hc2-layers-be096c96613565bc39ad4133cc301abb.mp4";